export default "__VITE_ASSET__1Muy5Qhp__"